export function normalizeQuote(data) {
  if (!Array.isArray(data) || data.length < 60 || !(Number(data[3]) > 0) || !Number.isFinite(Number(data[3]))) throw new Error('港股行情格式异常')
  return { name: data[1], price: data[3], change: data[32], high: data[33], low: data[34], open: data[5], close: data[4], volume: data[36], amount: data[37], amplitude: data[43], marketValue: data[45], floatValue: data[44], pe: data[57], pb: data[58], turnover: data[59] }
}

export function orderError({ side, tradeType, contractId, code, quantity, price, priceType, sellable }) {
  if (!['buy', 'sell'].includes(side) || ![1, 2].includes(tradeType)) return '请选择有效的交易操作及方向'
  if (!contractId) return '请选择港股合约'
  if (!/^hk\d{5}$/.test(code)) return '无效的港股代码'
  if (!Number.isSafeInteger(Number(quantity)) || Number(quantity) <= 0) return '请输入正整数股数'
  if (side === 'buy' && Number(quantity) % 100 !== 0) return '当前系统开仓数量须为100股整数倍'
  if (side === 'sell' && (!Number.isFinite(sellable) || Number(quantity) > sellable)) return '平仓数量超过当前方向持仓股数'
  if (priceType === 0 && (!Number.isFinite(Number(price)) || Number(price) <= 0)) return '请输入有效的限价'
  return ''
}

export function parseTrades(rows) {
  return rows.filter(row => typeof row === 'string').map(row => {
    const fields = row.split('/')
    return { id: fields[0], time: fields[1], price: fields[2], volume: fields[4], direction: fields[6] }
  }).filter(row => row.time && row.price)
}
